import React from 'react';
import styled from 'styled-components';

import Icon from '@ant-design/icons';
import TwoVerticalLineIcon from '@icons/sankey/two-vertical-line.svg';

const DragButtonWrapper = styled(Icon)`
  && {
    height: 26px;
    padding: 4px 0;
    font-size: 18px;
    color: rgba(0, 0, 0, 0.45);
    cursor: ew-resize;

    &:hover {
      color: #0046ff;
      background: #f2f6ff;
    }
  }
`;

const DragButton: React.FC<any> = (props) => {
  return <DragButtonWrapper component={TwoVerticalLineIcon} {...props} />;
};

export default DragButton;
